export function applyComposerFormat({
  formatType,
  richEditorRef,
  isComposerToolbarOpen,
  textRef,
  messageRef,
  saveComposerHistory,
  applyComposerState,
  enterUrlLabel,
}) {
  const editor = richEditorRef.current;
  if (editor && isComposerToolbarOpen) {
    editor.focus();
    switch (formatType) {
      case "bold":
        document.execCommand("bold", false, null);
        break;
      case "italic":
        document.execCommand("italic", false, null);
        break;
      case "underline":
        document.execCommand("underline", false, null);
        break;
      case "strikethrough":
        document.execCommand("strikeThrough", false, null);
        break;
      case "unordered":
        document.execCommand("insertUnorderedList", false, null);
        break;
      case "ordered":
        document.execCommand("insertOrderedList", false, null);
        break;
      case "left":
        document.execCommand("justifyLeft", false, null);
        break;
      case "center":
        document.execCommand("justifyCenter", false, null);
        break;
      case "right":
        document.execCommand("justifyRight", false, null);
        break;
      case "justify":
        document.execCommand("justifyFull", false, null);
        break;
      case "link": {
        const url = window.prompt(enterUrlLabel || "Enter URL");
        if (url) {
          document.execCommand("createLink", false, url);
        }
        break;
      }
      default:
        break;
    }
    return;
  }

  const textarea = textRef.current;
  if (!textarea) return;

  const currentMessage = messageRef.current || "";
  const start = textarea.selectionStart ?? currentMessage.length;
  const end = textarea.selectionEnd ?? currentMessage.length;
  const selectedText = currentMessage.slice(start, end);
  let replacementText = selectedText;
  let nextSelectionStart = start;
  let nextSelectionEnd = end;

  switch (formatType) {
    case "bold":
      replacementText = `**${selectedText || "text"}**`;
      nextSelectionStart = start + 2;
      nextSelectionEnd = selectedText ? end + 2 : start + replacementText.length - 2;
      break;
    case "italic":
      replacementText = `*${selectedText || "text"}*`;
      nextSelectionStart = start + 1;
      nextSelectionEnd = selectedText ? end + 1 : start + replacementText.length - 1;
      break;
    case "underline":
      replacementText = `<u>${selectedText || "text"}</u>`;
      nextSelectionStart = start + 3;
      nextSelectionEnd = selectedText ? end + 3 : start + replacementText.length - 4;
      break;
    case "strikethrough":
      replacementText = `~~${selectedText || "text"}~~`;
      nextSelectionStart = start + 2;
      nextSelectionEnd = selectedText ? end + 2 : start + replacementText.length - 2;
      break;
    case "unordered":
      replacementText = (selectedText || "list item")
        .split("\n")
        .map((line) => (line.trim() ? `- ${line}` : line))
        .join("\n");
      nextSelectionStart = start;
      nextSelectionEnd = start + replacementText.length;
      break;
    case "ordered":
      replacementText = (selectedText || "list item")
        .split("\n")
        .map((line, index) => (line.trim() ? `${index + 1}. ${line}` : line))
        .join("\n");
      nextSelectionStart = start;
      nextSelectionEnd = start + replacementText.length;
      break;
    case "left":
    case "center":
    case "right":
    case "justify":
      replacementText = `<div align="${formatType}">${selectedText || "text"}</div>`;
      nextSelectionStart = start;
      nextSelectionEnd = start + replacementText.length;
      break;
    case "link": {
      const url = window.prompt(enterUrlLabel || "Enter URL");
      if (!url) return;
      const linkText = selectedText || url;
      replacementText = `[${linkText}](${url})`;
      nextSelectionStart = start;
      nextSelectionEnd = start + replacementText.length;
      break;
    }
    default:
      return;
  }

  const nextMessage = `${currentMessage.slice(0, start)}${replacementText}${currentMessage.slice(end)}`;
  saveComposerHistory(currentMessage);
  applyComposerState(nextMessage, nextSelectionStart, nextSelectionEnd);
}
